import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useNISData = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const addNIS = async (data) => {
      try {
        setLoading(true);
        const response = await axiosApi.post('/nis/insert', data);
        if (response && response.data && (response.status === 200 || response.status === 201)) {
          setSuccess('Data successfully added!');
          setError(null);
          return { success: true };
        }
        setError(response.data?.message || 'Failed to add data.');
        return { success: false };
      } catch (err) {
        setError(err.response?.data?.message || 'An error occurred while adding NIS data.');
        setSuccess(null);
        return { success: false };
      } finally {
        setLoading(false);
      }
  };

  return { loading, success, error, setSuccess, setError, addNIS };
};


export default useNISData;